<!-- <template>
	<type-wrapper class="type-R" regular :bgImage="showData.image" :bgColor="showData.bg_color" v-if="mdContent">
		<markdown-it-vue-light class="md-body" :content="content"></markdown-it-vue-light>
	</type-wrapper>
</template>

<script>
	import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js'
	import 'mh2 Heading
h3 Heading
h4 Heading
h5 Heading
h6 Heading
Alternatively, for H1 and H2, an underline-ish style:

Alt-H1rkdown-it-vue/dist/markdown-it-vue-light.css'
	// markdown文本
	import mixin from '../mixin.js'
	export default {
		name: 'type-R',
		mixins: [ mixin ],
		computed: {
			mdContent() {
				return this.showData.tuwen_content || '';
			}
		},
		components: {
			MarkdownItVueLight
			//'markdown-it-vue-light': MarkdownItVueLight
		},
		data() {
			//console.log('MDCONTENT!!',this.showData.tuwen_content)
			return {
				contentx:'- [x] Finish my changes \n **This is bold text**',
				content: `# h1 Heading 8-)
## h2 Heading
### h3 Heading
#### h4 Heading
##### h5 Heading
###### h6 Heading

Alternatively, for H1 and H2, an underline-ish style:

Alt-H1
======
Alt-H2
------
Emphasis, aka italics, with *asterisks* or _underscores_.

Strong emphasis, aka bold, with **asterisks** or __underscores__.

Combined emphasis with **asterisks and _underscores_**.

Strikethrough uses two tildes. ~~Scratch this.~~

**This is bold text**

__This is bold text__

*This is italic text*

_This is italic text_

~~Strikethrough~~
1. First ordered list item
2. Another item
⋅⋅* Unordered sub-list.
1. Actual numbers don't matter, just that it's a number
⋅⋅1. Ordered sub-list
4. And another item.

⋅⋅⋅You can have properly indented paragraphs within list items. Notice the blank line above, and the leading spaces (at least one, but we'll use three here to also align the raw Markdown).

⋅⋅⋅To have a line break without a paragraph, you will need to use two trailing spaces.⋅⋅
⋅⋅⋅Note that this line is separate, but within the same paragraph.⋅⋅
⋅⋅⋅(This is contrary to the typical GFM line break behaviour, where trailing spaces are not required.)

* Unordered list can use asterisks
- Or minuses
+ Or pluses

1. Make my changes
    1. Fix bug
    2. Improve formatting
        - Make the headings biggerh2 Heading
h3 Heading
h4 Heading
h5 Heading
h6 Heading
Alternatively, for H1 and H2, an underline-ish style:

Alt-H1
2. Push my commits to GitHub
3. Open a pull request
    * Describe my changes
    * Mention all the members of my team
        * Ask for feedback

+ Create a list by starting a line with 
+ Sub-lists are made by indenting 2 spaces:
  - Marker character change forces new list start:
    * Ac tristique libero volutpat at
    + Facilisis in pretium nisl aliquet
    - Nulla volutpat aliquam velit
+ Very easy!
- [x] Finish my changes
- [ ] Push my commits to GitHub
- [ ] Open a pull request
- [x] @mentions, #refs, [links](), **formatting**, and <del>tags</del> supported
- [x] list syntax required (any unordered or ordered list supported)
- [x] this is a complete item
- [ ] this is an incomplete item
[I'm an inline-style link](https://www.google.com)

[I'm an inline-style link with title](https://www.google.com "Google's Homepage")

[I'm a reference-style link][Arbitrary case-insensitive reference text]

[I'm a relative reference to a repository file](../blob/master/LICENSE)

[You can use numbers for reference-style link definitions][1]

Or leave it empty and use the [link text itself].

URLs and URLs in angle brackets will automatically get turned into links.
http://www.example.com or <http://www.example.com> and sometimes
example.com (but not on Github, for example).

Some text to show that the reference links can follow later.

[arbitrary case-insensitive reference text]: https://www.mozilla.org
[1]: http://slashdot.org
[link text itself]: http://www.reddit.com
Here's our logo (hover to see the title text):

Inline-style:
![alt text](https://github.com/adam-p/markdown-here/raw/master/src/common/images/icon48.png "Logo Title Text 1")

Reference-style:
![alt text][logo]

[logo]: https://github.com/adam-p/markdown-here/raw/master/src/common/images/icon48.png "Logo Title Text 2"

![Minion](https://octodex.github.com/images/minion.png)
![Stormtroopocat](https://octodex.github.com/images/stormtroopocat.jpg "The Stormtroopocat")

Like links, Images also have a footnote style syntax

![Alt text][id]

With a reference later in the document defining the URL location:

[id]: https://octodex.github.com/images/dojocat.jpg  "The Dojocat"
Colons can be used to align columns.

| Tables        | Are           | Cool  |
| ------------- |:-------------:| -----:|
| col 3 is      | right-aligned | $1600 |
| col 2 is      | centered      |   $12 |
| zebra stripes | are neat      |    $1 |

There must be at least 3 dashes separating each header cell.
The outer pipes (|) are optional, and you don't need to make the
raw Markdown line up prettily. You can also use inline Markdown.

Markdown | Less | Pretty
--- | --- | ---
*Still* | renders| **nicely**
1 | 2 | 3

| First Header  | Second Header |
| ------------- | ------------- |
| Content Cell  | Content Cell  |
| Content Cell  | Content Cell  |

| Command | Description |
| --- | --- |
| git status | List all new or modified files |
| git diff | Show file differences that haven't been staged |

| Command | Description |
| --- | --- |


| Left-aligned | Center-aligned | Right-aligned |
| :---         |     :---:      |          ---: |
| git status   | git status     | git status    |
| git diff     | git diff       | git diff      |

| Name     | Character |
| ---      | ---       |
| Backtick |         |
| Pipe     |         |
> Blockquotes are very handy in email to emulate reply text.
> This line is part of the same quote.

Quote break.

> This is a very long line that will still be quoted properly when it wraps. Oh boy let's keep writing to make sure this is long enough to actually wrap for everyone. Oh, you can *put* **Markdown** into a blockquote.

> Blockquotes can also be nested...
>> ...by using additional greater-than signs right next to each other...
> > > ...or with spaces between arrows.
        `,
			}
 		}
	}
</script>

<style scoped lang="less">
	.type-R{}
</style>
 -->






 <template>
	<type-wrapper
	  class="type-R"
	  regular
	  :bgImage="showData.image"
	  :bgColor="showData.bg_color"
	  v-if="mdContent"
	>
	  <div class="md-body" v-html="renderedContent"></div>
	</type-wrapper>
  </template>
  
  <script>
  import MarkdownIt from 'markdown-it';
  import mixin from '../mixin.js';
  
  export default {
	name: 'type-R',
	mixins: [mixin],
	computed: {
	  mdContent() {
		return this.showData.tuwen_content || '';
	  },
	  renderedContent() {
		const md = new MarkdownIt({
		  html: true,
		  linkify: true,
		  typographer: true,
		  breaks: true, // Convert \n to <br>
		});
		// Do not include the markdown-it-anchor plugin to prevent header links
		return md.render(this.mdContent);
	  },
	},
  };
  </script>
  
  <style scoped lang="less">
  .type-R {
	.md-body {
    font-size: 2.1rem;
    line-height: 2;
    color: #333;
    margin: 0;
    padding: 0;

    /* Style headings */
    h1 {
      font-size: 3em;
      margin-bottom: 1em;
    }
    h2 {
      font-size: 2.8em;
      margin-bottom: 1em;
    }
    h3 {
      font-size: 2.6em;
      margin-bottom: 1em;
    }
    h4 {
      font-size: 2.5em;
      margin-bottom: 1em;
    }
    h5 {
      font-size: 2.3em;
      margin-bottom: 1em;
    }
    h6 {
      font-size: 2.2em;
      margin-bottom: 1em;
    }

    /* Style paragraphs */
    p {
      margin-bottom: 2em;
    }

    /* Style lists */
    ul,
    ol {
      margin-left: 2.5em;
      margin-bottom: 1em;
    }

    /* Style tables */
    table {
      width: 100%; /* Adjusted to fit within container */
      border: 1.5px solid #2c1d1d;
      border-collapse: collapse; /* Important for border visibility */
      margin-bottom: 1em;
    }

    th,
    td {
      border: 1px solid #2c1d1d; /* Ensures borders are applied */
      padding: 8px;
      text-align: left;
    }

    th {
      background-color: #3b3333;
      color: rgb(32, 26, 26); /* To improve contrast */
    }

    /* Style links */
    a {
      color: #007bff;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
	img {
		max-width: 100%; /* Ensures the image will not exceed the screen width */
		max-height: 100vh; /* Ensures the image will not exceed the screen height */
		width: auto; /* Maintain aspect ratio */
		height: auto; /* Maintain aspect ratio */
		display: block; /* Prevents spacing issues around the image */
		margin: 0 auto; /* Center the image (if it's smaller than the container) */
	}
  
  }
	/* your styles */
  }
  </style>